



















import mixins from 'vue-typed-mixins';
import buildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { VendorLotId } from './VendorLotId';
import LotIdList from './LotIdList.vue';
import { ParkingPaymentVendor } from './Enums';
import EnumSelector from '@/Shared/EnumSelector.vue';

export default mixins(LocationBasedMixin).extend({
    beforeMount() {
        if (!this.$route.query.vendor) {
            return;
        }

        this.selectedVendor = ParkingPaymentVendor[(this.$route.query.vendor as any)] as any;
    },
    components: {
        EnumSelector,
        LotIdList
    },
    data() {
        return {
            i18nPrefix: 'admin.vendorLotIds',
            ParkingPaymentVendor,
            selectedVendor: null as ParkingPaymentVendor | null,
        };
    },
    watch: {
        async selectedVendor() {
            if (!this.selectedVendor) {
                return;
            }
            await this.$router.replace({
                name: this.$route.name ?? undefined,
                query: {
                    vendor: ParkingPaymentVendor[this.selectedVendor]
                }
            });
        },
    },
});
